import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import ScrollToTop from "./components/ScrollToTop";
import ScrollToTopButton from "./components/ScrollToTopButton";
import CookieBanner from "./components/CookieBanner";

import AnalyticsProvider from "./components/AnalyticsProvider";

import { lazy, Suspense } from "react";

import Navigation from "./components/Navigation";
import Index from "./pages/Index";

const NotFound = lazy(() => import("./pages/NotFound"));
const OMiejscu = lazy(() => import("./pages/OMiejscu"));
const Galeria = lazy(() => import("./pages/Galeria"));
const SesjeBiznesowe = lazy(() => import("./pages/SesjeBiznesowe"));
const Cennik = lazy(() => import("./pages/Cennik"));
const Kontakt = lazy(() => import("./pages/Kontakt"));
const PolitykaPrywatnosci = lazy(() => import("./pages/PolitykaPrywatnosci"));

const queryClient = new QueryClient();

const PageLoader = () => (
  <div className="min-h-screen bg-background">
    <Navigation />
  </div>
);

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <ScrollToTop />
        <AnalyticsProvider />
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/o-miejscu" element={<OMiejscu />} />
            <Route path="/wynajem-studia" element={<Galeria />} />
            <Route path="/sesje" element={<SesjeBiznesowe />} />
            <Route path="/cennik" element={<Cennik />} />
            <Route path="/kontakt" element={<Kontakt />} />
            <Route path="/polityka-prywatnosci" element={<PolitykaPrywatnosci />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
        <Navigation />
        <ScrollToTopButton />
        <CookieBanner />
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
